// ─────────────────────────────────────────────────────────────────────────────
// WHAT HAPPENS WHEN A NOTIFICATION IS CLICKED.
//
// Extracted from NotificationBell (sitting 4.2/4.3) so the bell panel and the
// merged Notifications page do exactly the same thing. Two copies of this would
// drift, and a notification that behaves differently depending on where you
// clicked it is the kind of thing nobody notices until a customer does.
// ─────────────────────────────────────────────────────────────────────────────
import { notificationView } from '../nav/views';

// The client's own section per type, for a notification that arrived without the server's `view`
// (types the server no longer creates; the server's destinations are the source).
const SECTION_FOR_TYPE = {
  mention: 'Tasks',
  task_assigned: 'Tasks',
  meeting_invitation: 'Calendar',
  aidey_action_done: 'Settings',
  aidey_intelligence: 'Settings',
  leave_request: 'TeamHR',
  leave_approved: 'TeamHR',
  leave_refused: 'TeamHR',
  leave_cancelled: 'TeamHR',
  payment_issue: 'Invoices',
  invoice_overdue: 'Invoices',
  renewal_due: 'Renewals',
  subscription_updated: 'Settings',
  subscription_canceled: 'Settings',
  usage_warning: 'Settings',
  timesheet_reminder: 'Timesheet', // Block M2: the server's link opens the week itself
  crm_card_moved: 'CRM',          // TEAM-1b, decision 34: a colleague moved a contact you look after
};

// isPersonal: personalFlag() of the active workspace (true, false, or null while
// unknown). A section that does not exist in that workspace opens Notifications.
//
// Carla's item 8 (2026-10-12): a notification opens its item, or its section, and NEVER the Aidey
// chat. The actionable branch that primed the chat with the notification is gone: an approval opens
// the page where it is approved. The server gives every notification a destination (`link`, and
// `view` for the section: "Aidey Backend/lib/notificationRegistry.js" destinationFor). The caller
// marks it read first (the bell, the Notifications page, the Dashboard's card).
export function openNotification(notification, setFilter, isPersonal = null) {
  // The item deep-link wins: it opens the specific entity, not just its section.
  if (notification.link) {
    window.dispatchEvent(new CustomEvent('aidey:navigate', { detail: notification.link }));
    return;
  }
  if (!setFilter) return;
  const view = notification.view || SECTION_FOR_TYPE[notification.type] || 'Notifications';
  setFilter(notificationView(view, isPersonal));
}

// "Needs a decision" = actionable, or urgent whatever its type. This is the rule
// itself, in one place: chat may surface these, only her action clears them.
// 2026-10-21: or until its moment has passed: the server marks those `resolved` (Aidey
// Backend/lib/notificationResolve.js: the booking has happened, the expense was decided...).
export function needsDecision(n) {
  return Boolean(n && !n.dismissed && !n.resolved && (n.actionable || n.priority === 'high' || n.priority === 'urgent'));
}

export { SECTION_FOR_TYPE };
